export default "__VITE_ASSET__6292a0ac__"